/* eslint-disable import/no-cycle */
import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react';

import { getCurrentToken } from '../shared/utils';
import { handleErrorByType } from './error';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers) => {
    const token = getCurrentToken();
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQueryWithErrorHandling: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  unknown,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error) {
    const { data } = result.error as { status?: number; data?: any };

    if (data) {
      const isErrorHandled = handleErrorByType(data);

      result.error = {
        ...result.error,
        data: {
          ...data,
          isErrorHandled,
        },
      };
    }
  }

  return result;
};
